var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function BoxIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61785 9.53272L12.01 10.8608L18.967 7.01654L16.4844 5.63794L9.61785 9.53272ZM14.436 4.50047L12 3.14771L5.05931 7.00194L7.56924 8.39538L14.436 4.50047ZM13 20.3031L20 16.4054V8.72926L13 12.5904V20.3031ZM11 12.5885L4 8.70154V16.4212L11 20.305V12.5885ZM2.51436 6.12584L11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7V17C22 17.3632 21.8031 17.6978 21.4856 17.8742L12.4856 22.8742C12.1836 23.0419 11.8164 23.0419 11.5144 22.8742L2.51436 17.8742C2.19689 17.6978 2 17.3632 2 17V7C2 6.63683 2.19689 6.30221 2.51436 6.12584ZM5.52095 13.1744C5.03958 12.9036 4.86883 12.2939 5.13957 11.8126C5.41032 11.3312 6.02002 11.1605 6.50139 11.4312L8.99242 12.8323C9.47379 13.103 9.64454 13.7127 9.37379 14.1941C9.10305 14.6755 8.49334 14.8462 8.01197 14.5755L5.52095 13.1744Z",
    fill: ""
  }));
}
export var BoxIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: BoxIconInner
  }, props));
};